<div class="taCheckBox" [ngClass]="{'checked': isSelected, 'left': textPosition=='left'}" (click)="toggle()">
    <i class="taCheckBox-icon icon-checked"></i> <span class="taCheckBox-text">{{displayText}}</span>
</div>
